import * as logger from '../logging/logger';

export function logUncaughtErrors() {
    window.onerror = function myErrorHandler(error, url, lineNumber) {
        logger.log('Error', `UncaughtErrorHandler: ${error} url:${url} lineNumber:${lineNumber}`);
        return false;
    };
}
